import { useI18n } from "react-simple-i18n";
import { alpha, styled } from "@mui/material/styles";
import { Typography } from "@mui/material";

import { Layout } from "../components/layout/layout";
import { GlobalFirstSection } from "../components/layout/styles";

const About = () => {
	const { t } = useI18n();

	return (
		<Layout>
			<AboutWrapper>
				<Typography variant="h1">
					{t("about.title")}
				</Typography>

				<Typography variant="h6">
					{t("about.description")}
				</Typography>
			</AboutWrapper>
		</Layout>
	)
}

const AboutWrapper = styled(GlobalFirstSection)(({ theme }) => ({
	display: 'flex',
	flexDirection: "column",
	alignItems: 'center',
	gap: theme.spacing(5),
	padding: `${theme.spacing(15)} 0px`,
	textAlign: "center",

	h6: {
		maxWidth: 600,
		color: alpha(theme.palette.common.firstColor, 0.75),
	},

	[theme.breakpoints.down("md")]: {
		gap: theme.spacing(3),
		padding: `${theme.spacing(8)} 0px`,
	}
}))

export { About }